import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CalendarRoomRow from './CalendarRoomRow';

const CalendarRooms = props => {
  return (
    <Table celled className="table booking__calendar_table booking__calendar_table-rooms">
      <Table.Body>
        {props.bookingRooms.map((room, r_i) => {
          return <CalendarRoomRow key={r_i} room={room} index={r_i} />;
        })}
      </Table.Body>
    </Table>
  );
};

CalendarRooms.propTypes = {
  bookingRooms: PropTypes.array
};

CalendarRooms.defaultProps = {};

export default connect(state => ({
  project: state.projects.single.active,
  currentMonth: state.projects.single.booking.currentMonth
}))(CalendarRooms);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/booking/CalendarRooms.js